/* eslint-disable import/no-cycle */
import React, { useState } from 'react';
import classNames from 'classnames';
import {
  OverlayPopover,
  Placement,
} from '../../../../../../../shared/design-system/components/overlay';
import { accessibleOnClick } from '../../../../../../../shared/utils/accessible-on-click';
import DataCard from './data-card/data-card';
import GenericCustomOutcomeDropdown from '../../../../../../settings/components/custom-outcomes/components/custom-outcome-dropdown';
import {
  getOptionFromOutcome,
  mapOutcomeToOption,
} from '../../../../../../sequence/components/sequence-single-content/components/sequence-single-contacts/components/prospect-outcome-select/utils/helper';
import { getOutcomeIcon } from '../../../../../../sequence/components/sequence-single-content/components/sequence-single-contacts/components/contact-list-content/components/helpers/step-filter-mapper';

interface OutcomeCellProps {
  sequences: any[];
  prospectId: string | number;
  allOutcomes: any;
  // eslint-disable-next-line react/require-default-props
  disable?: boolean;
  // eslint-disable-next-line react/require-default-props
  showProspectOutcomeChip?: boolean;
}

const OutcomeCell = ({
  sequences,
  prospectId,
  allOutcomes,
  disable = false,
  showProspectOutcomeChip = false,
}: OutcomeCellProps) => {
  const categoryId = sequences?.[0]?.categoryId;
  const [isVisibleAllSequences, setIsVisibleAllSequences] = useState<boolean>(
    false,
  );

  const mappedCell = sequences?.length
    ? sequences.map((sequence) => ({
        sequenceId: sequence.id,
        sequence: sequence.title,
        status: sequence.status,
        prospectId,
        categoryId: sequence?.categoryId,
        allOutcomes,
      }))
    : [];

  const cls = classNames([
    'regular-2 blue-txt-11 sequence-name font-medium',
    {
      'underline-txt': isVisibleAllSequences,
    },
  ]);

  const onToggle = () => {
    setIsVisibleAllSequences(!isVisibleAllSequences);
  };

  const showAllSequences = () => {
    setIsVisibleAllSequences(true);
  };

  const renderOverlayPopoverSpan = (
    <OverlayPopover
      show={isVisibleAllSequences}
      onToggle={onToggle}
      className="sequence-name-popover"
      content={
        <DataCard
          data={mappedCell}
          showAllSequences={onToggle}
          allOutcomes={allOutcomes}
          showProspectOutcomeChip={showProspectOutcomeChip}
        />
      }
      placement={Placement.Auto}
      rootClose
    >
      <span
        role="button"
        {...accessibleOnClick(showAllSequences)}
        className={cls}
      >
        View Outcomes
      </span>
    </OverlayPopover>
  );

  const renderSpan = () => {
    const firstElement = sequences.shift();

    if (firstElement) {
      return !showProspectOutcomeChip ? (
        <GenericCustomOutcomeDropdown
          showFooter={false}
          options={mapOutcomeToOption(allOutcomes)}
          showTotal={false}
          className="prospect-outcome-select"
          changeOutcomeRequestPayload={{
            sequenceId: firstElement.id,
            prospectId,
          }}
          initialSelectedOption={getOptionFromOutcome(allOutcomes, categoryId)}
          optionRenderer={(option) => (
            <div className="d-flex align-items-center">
              {getOutcomeIcon(option?.name, false, {
                isDefault: option.isDefault,
                sentiment: option.sentiment,
              })}
              <span className="ml-1">{option.name}</span>
            </div>
          )}
          disableDropdownOpening={disable}
        />
      ) : (
        <div
          className={classNames([
            'prospect-custom-outcome-select',
            'outcome-chip',
            {
              'positive-sentiment':
                getOptionFromOutcome(allOutcomes, categoryId)?.sentiment ===
                'Positive',
              'negative-sentiment':
                getOptionFromOutcome(allOutcomes, categoryId)?.sentiment ===
                'Negative',
              'neutral-sentiment':
                getOptionFromOutcome(allOutcomes, categoryId)?.sentiment ===
                'Neutral',
              'default-sentiment': !getOptionFromOutcome(
                allOutcomes,
                categoryId,
              )?.sentiment,
            },
          ])}
        >
          <div className="selected-outcome-main">
            <div>
              {getOutcomeIcon(
                getOptionFromOutcome(allOutcomes, categoryId)?.name,
                false,
                {
                  isDefault: getOptionFromOutcome(allOutcomes, categoryId)
                    ?.isDefault,
                  sentiment: getOptionFromOutcome(allOutcomes, categoryId)
                    ?.sentiment,
                },
              )}
              <span>
                {getOptionFromOutcome(allOutcomes, categoryId)?.name ??
                  'Uncategorized'}
              </span>
            </div>
          </div>
        </div>
      );
    }

    return '-';
  };

  return (
    <div className="sequence-name-wrap">
      {mappedCell?.length > 1 ? renderOverlayPopoverSpan : renderSpan()}
    </div>
  );
};

export default OutcomeCell;
